import { EffectiveMarginAvailability, EffectiveMarginDecimal } from '@/types/effectiveMargin';

const groupDecimal = (value: string): string => {
  const match = value.match(/^(-?)(\d+)(\.\d+)?$/);
  if (!match) return value;
  return `${match[1]}${match[2].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${match[3] || ''}`;
};

export const formatExactNumber = (value: EffectiveMarginDecimal): string =>
  value === null ? 'Unavailable' : groupDecimal(value);

export const formatExactCurrency = (value: EffectiveMarginDecimal): string => {
  if (value === null) return 'Unavailable';
  const grouped = groupDecimal(value);
  return grouped.startsWith('-') ? `-$${grouped.slice(1)}` : `$${grouped}`;
};

export const formatAvailableCurrency = (
  value: EffectiveMarginDecimal,
  availability: EffectiveMarginAvailability,
): string => availability === 'UNAVAILABLE'
  ? 'Unavailable'
  : `${formatExactCurrency(value)}${availability === 'PARTIAL' ? ' (partial)' : ''}`;

export const formatSourceTime = (value: string | null, missing = 'Source date unavailable'): string =>
  value ? new Date(value).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' }) : missing;
